import React, { Suspense, useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import s from './styles.module.css';
import { fetchOrders } from '../../api/cargo-moderator-api/cargo-moderator-api';
import { useCities } from '../../api/user-list-api/user-list-api';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ru } from 'date-fns/locale';
import { axiosInstances } from '../../api/axios-instances';
import { jwtDecode } from 'jwt-decode';
import Spinner from '../UI/Spinner/Spinner';
import UserOrder from './order-table/order-table';
import Cookies from 'js-cookie';
import NewSelector from '../UI/NewSelector/NewSelector';
import FilterChina from '../UI/filterChina/filterChina';
import { useLocation, useNavigate } from 'react-router-dom';
import {useSearchInputStore} from "../../store/search-input-store/search-input-store";

registerLocale('ru', ru);

const getOrders = async ({ queryKey }) => {
    const [, { cityId, filialId, forSearch, status, dateFrom, dateTo, selector, plagination }] =
        queryKey;
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 100); // Исправлено на 3 месяца
    const formattedDateFrom = dateFrom || threeMonthsAgo.toISOString().split('T')[0];
    const addOneDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate.toISOString().split('T')[0];
    };
    const formattedDateTo = dateTo ? addOneDay(dateTo) : addOneDay(today);
    const token = Cookies.get('token');
    if (!token) {
        throw new Error('Token is not available in localStorage');
    }

    const response = await axiosInstances.get('/amantrans/orders', {
        params: {
            dateFrom: formattedDateFrom,
            dateTo: formattedDateTo,
            cityId,
            filialId,
            forSearch,
            status,
            page: plagination,
            size: selector,
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    if (response.status !== 200) {
        throw new Error(`Error: ${response.status}`);
    }
    return response.data;
};

const SearchInput = ({
    handleOpenModal,
    searchInput,
    setSearchInput,
    handleSUserFind,
    showAll,
    handleShowAll,
    translation,
}) => {
    const handleInputChange = (e) => {
        const cleanedInput = e.target.value.trim().replace(/\s+/g, ' ');
        setSearchInput(cleanedInput);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSUserFind();
        }
    };

    return (
        <div className={s['input']}>
            <input
                className={s['input-style']}
                placeholder={translation('searchPlaceholder')}
                value={searchInput}
                onChange={handleInputChange} // Обработчик изменения текста
                onKeyDown={handleKeyDown} // Обработчик нажатия клавиш
            />
            <div className={s['div-china-button']}>
                {showAll ? (
                    <button className={s['button-text']} onClick={handleShowAll}>
                        {translation('showAll')}
                    </button>
                ) : (
                    <button className={s['button-text']} onClick={handleSUserFind}>
                        {translation('findOrder')}
                    </button>
                )}
                <button className={s['button-text']} onClick={handleOpenModal}>
                    {translation('createOrder')}
                </button>
            </div>
        </div>
    );
};

const OrderFilters = ({
    handleShowAll,
    translation,
    activeFilter,
    openModalFilter,
    containerRef,
    toggleDropdown,
    number,
    dropdownVisible,
    handleChangeSelector,
}) => (
    <div className={s['order-create']}>
        <button onClick={handleShowAll} className={s['filter-button-new']}>
            {translation('allOrdersShow')}
        </button>
        <button
            className={`${s['filter-button-new']} ${activeFilter === true ? s['activeFilter'] : ''}`}
            onClick={openModalFilter}
        >
            {translation('allFilterButton')}
            <svg width="25" height="22" viewBox="0 0 25 22" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.0645 21.7036C16.4863 21.7036 15.9551 21.5591 15.4707 21.27C14.9941 20.9888 14.6113 20.6099 14.3223 20.1333C14.041 19.6567 13.9004 19.1294 13.9004 18.5513C13.9004 17.9731 14.041 17.4458 14.3223 16.9692C14.6113 16.4849 14.9941 16.1021 15.4707 15.8208C15.9551 15.5317 16.4863 15.3872 17.0645 15.3872C17.6504 15.3872 18.1816 15.5317 18.6582 15.8208C19.1348 16.1021 19.5137 16.4849 19.7949 16.9692C20.084 17.4458 20.2285 17.9731 20.2285 18.5513C20.2285 19.1294 20.084 19.6567 19.7949 20.1333C19.5137 20.6099 19.1309 20.9888 18.6465 21.27C18.1699 21.5591 17.6426 21.7036 17.0645 21.7036ZM17.0645 20.0278C17.4785 20.0278 17.8301 19.8833 18.1191 19.5942C18.4082 19.3052 18.5527 18.9575 18.5527 18.5513C18.5527 18.1294 18.4082 17.7778 18.1191 17.4966C17.8301 17.2075 17.4785 17.063 17.0645 17.063C16.6582 17.063 16.3105 17.2075 16.0215 17.4966C15.7324 17.7778 15.5879 18.1294 15.5879 18.5513C15.5879 18.9575 15.7324 19.3052 16.0215 19.5942C16.3105 19.8833 16.6582 20.0278 17.0645 20.0278ZM14.9785 17.3091V19.7817H1.52539C1.19727 19.7817 0.912109 19.6606 0.669922 19.4185C0.435547 19.1685 0.318359 18.8794 0.318359 18.5513C0.318359 18.2075 0.435547 17.9146 0.669922 17.6724C0.904297 17.4302 1.18945 17.3091 1.52539 17.3091H14.9785ZM23.709 17.3091C24.0371 17.3091 24.3184 17.4302 24.5527 17.6724C24.7871 17.9146 24.9043 18.2075 24.9043 18.5513C24.9043 18.8794 24.7871 19.1685 24.5527 19.4185C24.3184 19.6606 24.0371 19.7817 23.709 19.7817H19.2559V17.3091H23.709ZM8.28711 14.3208C7.70898 14.3208 7.17773 14.1763 6.69336 13.8872C6.2168 13.5981 5.83789 13.2153 5.55664 12.7388C5.27539 12.2622 5.13477 11.731 5.13477 11.145C5.13477 10.5669 5.27539 10.0396 5.55664 9.56299C5.83789 9.08643 6.2168 8.70752 6.69336 8.42627C7.17773 8.13721 7.70898 7.99268 8.28711 7.99268C8.86523 7.99268 9.39258 8.13721 9.86914 8.42627C10.3457 8.70752 10.7285 9.08643 11.0176 9.56299C11.3066 10.0396 11.4512 10.5669 11.4512 11.145C11.4512 11.731 11.3066 12.2622 11.0176 12.7388C10.7285 13.2153 10.3457 13.5981 9.86914 13.8872C9.39258 14.1763 8.86523 14.3208 8.28711 14.3208ZM8.28711 12.6333C8.70898 12.6333 9.06055 12.4888 9.3418 12.1997C9.63086 11.9106 9.77539 11.5591 9.77539 11.145C9.77539 10.7231 9.63086 10.3716 9.3418 10.0903C9.06055 9.80908 8.70898 9.66846 8.28711 9.66846C7.87305 9.66846 7.52148 9.80908 7.23242 10.0903C6.94336 10.3716 6.79883 10.7231 6.79883 11.145C6.79883 11.5591 6.94336 11.9106 7.23242 12.1997C7.52148 12.4888 7.87305 12.6333 8.28711 12.6333ZM1.50195 9.90283H6.1543V12.3872H1.50195C1.18164 12.3872 0.904297 12.2661 0.669922 12.0239C0.435547 11.7739 0.318359 11.481 0.318359 11.145C0.318359 10.8091 0.435547 10.52 0.669922 10.2778C0.904297 10.0278 1.18164 9.90283 1.50195 9.90283ZM23.6855 9.90283C24.0215 9.90283 24.3066 10.0239 24.541 10.2661C24.7832 10.5083 24.9043 10.8013 24.9043 11.145C24.9043 11.4888 24.7832 11.7817 24.541 12.0239C24.3066 12.2661 24.0215 12.3872 23.6855 12.3872H10.3262V9.90283H23.6855ZM17.0645 6.91455C16.4863 6.91455 15.9551 6.77002 15.4707 6.48096C14.9941 6.19189 14.6113 5.80908 14.3223 5.33252C14.041 4.85596 13.9004 4.32861 13.9004 3.75049C13.9004 3.17236 14.041 2.64502 14.3223 2.16846C14.6113 1.68408 14.9941 1.30127 15.4707 1.02002C15.9551 0.730957 16.4863 0.586426 17.0645 0.586426C17.6426 0.586426 18.1699 0.730957 18.6465 1.02002C19.1309 1.30127 19.5137 1.68408 19.7949 2.16846C20.084 2.64502 20.2285 3.17236 20.2285 3.75049C20.2285 4.32861 20.084 4.85596 19.7949 5.33252C19.5137 5.80908 19.1309 6.19189 18.6465 6.48096C18.1699 6.77002 17.6426 6.91455 17.0645 6.91455ZM17.0645 5.23877C17.4785 5.23877 17.8301 5.09424 18.1191 4.80518C18.4082 4.5083 18.5527 4.15283 18.5527 3.73877C18.5527 3.32471 18.4082 2.97705 18.1191 2.6958C17.8301 2.40674 17.4785 2.26221 17.0645 2.26221C16.6582 2.26221 16.3105 2.40674 16.0215 2.6958C15.7324 2.97705 15.5879 3.32471 15.5879 3.73877C15.5879 4.15283 15.7324 4.5083 16.0215 4.80518C16.3105 5.09424 16.6582 5.23877 17.0645 5.23877ZM15.0137 2.5083V4.99268H1.52539C1.19727 4.99268 0.912109 4.86768 0.669922 4.61768C0.435547 4.36768 0.318359 4.07861 0.318359 3.75049C0.318359 3.41455 0.435547 3.12549 0.669922 2.8833C0.904297 2.6333 1.18945 2.5083 1.52539 2.5083H15.0137ZM23.709 2.5083C24.0371 2.5083 24.3184 2.6333 24.5527 2.8833C24.7871 3.12549 24.9043 3.41455 24.9043 3.75049C24.9043 4.08643 24.7871 4.37939 24.5527 4.62939C24.3184 4.87158 24.0371 4.99268 23.709 4.99268H19.1387V2.5083H23.709Z" />
            </svg>
        </button>
        <div ref={containerRef}>
            <NewSelector
                toggleDropdown={toggleDropdown}
                number={number}
                dropdownVisible={dropdownVisible}
                handleSelectValue={handleChangeSelector}
                t={translation}
            />
        </div>
    </div>
);

const UserOrders = ({ isIOS, isMobile, t, language }) => {
    const {searchingCode, setSearchingCode} = useSearchInputStore();
    useEffect(() => {
        if(searchingCode) {
            setSearchInput('');
            setGetChinaParams({
                cityId: '',
                filialId: '',
                forSearch: searchingCode,
                status: '',
                dateFrom: '',
                dateTo: '',
                selector: number,
                plagination: page,
            });
        }
    }, [])


    const navigate = useNavigate();
    const location = useLocation();
    const [rowData, setRowData] = useState(location?.state?.status || '');

    const [searchInput, setSearchInput] = useState('');
    const [showAll, setShowAll] = useState(false);
    const { data: citiesData } = useCities();
    const {
        data: ordersData,
        error: ordersError,
        isLoading: ordersLoading,
    } = useQuery('orders', fetchOrders);
    const [city, setCity] = useState(null);
    const [number, setNumber] = useState(10);
    const [page, setPage] = useState(0);
    const [activeFilter, setActiveFilter] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showModalFilter, setShowModalFilter] = useState(false);
    const [getChinaParams, setGetChinaParams] = useState({
        cityId: '',
        filialId: '',
        forSearch: '',
        status: rowData || '',
        dateFrom: '',
        dateTo: '',
        selector: number,
        plagination: page,
    });
    const {
        data: initialData,
        error,
        isLoading,
        refetch,
    } = useQuery(['orders', getChinaParams], getOrders, { keepPreviousData: true });
    const containerRef = useRef();
    const [orderCreate, setOrderCreate] = useState({
        name: '',
        track_code: '',
        price: 0,
        weight: '',
        amount: '',
        customer_id: 0,
        city_id: 0,
        filial_id: 0,
    });
    const [createOpenModal, setCreateOpenModal] = useState(false);
    const [role, setRole] = useState(null);
    const token = Cookies.get('token');
    useEffect(() => {
        if (token && typeof token === 'string') {
            try {
                const decodedToken = jwtDecode(token);
                setRole(decodedToken.role);
            } catch (error) {
                console.error('Ошибка декодирования токена', error);
                setRole('');
            }
        } else {
            setRole('');
        }
    }, [token]);
    const handleCreateOpenModal = () => {
        setOrderCreate({
            name: '',
            track_code: '',
            price: 0,
            weight: '',
            amount: '',
            customer_id: 0,
            city_id: 0,
            filial_id: 0,
        });
        setCreateOpenModal(true);
    };

    const handleChangeSelector = (event) => {
        const selectedNumber = parseInt(event);
        setNumber(selectedNumber);
        setPage(0);
        setDropdownVisible(false);
        setGetChinaParams((prevParams) => ({
            ...prevParams,
            selector: selectedNumber,
        }));
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
        setGetChinaParams((prevParams) => ({
            ...prevParams,
            plagination: newPage,
        }));
    };

    const openModalFilter = () => {
        setShowModalFilter(true);
        setActiveFilter(true);
    };

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSUserFind = () => {
        setPage(0);
        setGetChinaParams({
            cityId: '',
            filialId: '',
            forSearch: searchInput,
            status: '',
            dateFrom: '',
            dateTo: '',
            selector: number,
            plagination: page,
        });
        setSearchingCode(searchInput);
        setSearchInput('');
    };

    const handleShowAll = () => {
        setRowData('');
        setPage(0);
        setGetChinaParams({
            cityId: '',
            filialId: '',
            forSearch: '',
            status: '',
            dateFrom: '',
            dateTo: '',
            selector: number,
            plagination: page,
        });
        setSearchInput('');
        setShowAll(false);
    };

    const tableOrder = initialData;
    const country = 'China';
    if (isLoading) return <Spinner />;
    if (error) return <div>{t('error')}</div>;
    if (ordersLoading) return <Spinner />;
    if (ordersError) return <div>{t('errorLoadingOrders')}</div>;

    return (
        <div className={s['container']}>
            <div className={s['content']}>
                <div className={s['change-cargo']}>
                    <div className={s['title']}>
                        <h1 className={s['title-text']}>{t('chinaCargos')}</h1>
                    </div>
                </div>
                <FilterChina
                    isIOS={isIOS}
                    isMobile={isMobile}
                    ordersData={ordersData}
                    language={language}
                    citiesData={citiesData}
                    role={role}
                    translation={t}
                    visible={showModalFilter}
                    setShowModal={setShowModalFilter}
                    setActiveFilter={setActiveFilter}
                    selector={number}
                    setSelector={setNumber}
                    setNumber={setNumber}
                    setGetTurkeyParams={setGetChinaParams}
                    setCity={setCity}
                    city={city}
                    country={country}
                />
                <div>
                    <>
                        <SearchInput
                            searchInput={searchInput}
                            setSearchInput={setSearchInput}
                            handleSUserFind={handleSUserFind}
                            showAll={showAll}
                            handleOpenModal={handleCreateOpenModal}
                            handleShowAll={handleShowAll}
                            translation={t}
                        />
                        <OrderFilters
                            handleShowAll={handleShowAll}
                            translation={t}
                            activeFilter={activeFilter}
                            openModalFilter={openModalFilter}
                            containerRef={containerRef}
                            toggleDropdown={toggleDropdown}
                            number={number}
                            dropdownVisible={dropdownVisible}
                            handleChangeSelector={handleChangeSelector}
                        />
                        <div className={s['order-div']}>
                            {tableOrder && (
                                <Suspense fallback={<Spinner />}>
                                    <UserOrder
                                        t={t}
                                        language={language}
                                        page={page}
                                        setPage={handlePageChange}
                                        number={number}
                                        ordersData={ordersData}
                                        handleChange={handleChangeSelector}
                                        tableOrder={tableOrder}
                                        createOpenModal={createOpenModal}
                                        setCreateOpenModal={setCreateOpenModal}
                                        orderCreate={orderCreate}
                                        setOrderCreate={setOrderCreate}
                                        translate={t}
                                        refetch={refetch}
                                    />
                                </Suspense>
                            )}
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
};

export default UserOrders;
